module.exports = __webpack_public_path__ + "/img/ChipArray-2side-Convex-Labeled-82bb0e.svg";